import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[coreNoLeadingSpace]',
  standalone: true,
})
export class NoLeadingSpaceDirective {
  private ngControl = inject(NgControl, { optional: true });

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.value.startsWith(' ')) {
      input.value = input.value.trimStart();
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(input.value);
      }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') || '';
    if (pastedText.startsWith(' ')) {
      event.preventDefault();
    }
  }
}
